import {lazy} from 'react'

const GiftShopUploadScreen = lazy(
  () => import(/* webpackChunkName: 'Upload' */ './GiftShopUploadScreen'),
)

export {GiftShopUploadScreen}
